module.exports = __webpack_public_path__ + "img/glm_gbt6172_1_2000.prt.7879977c.jpg";